import { ServishareketduzenlePage } from './../servishareketduzenle/servishareketduzenle';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, ViewController } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';


@Component({
  selector: 'page-servishareketdetay',
  templateUrl: 'servishareketdetay.html',
})
export class ServishareketdetayPage {
  Liste = [];
  vWKayit: any = {};
  HareketListesi = [];
  hareketid = "";
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public modalCtrl: ModalController,
    public viewCtrl: ViewController,
    public navParams: NavParams) {
    if (navParams.get("vWKayit") != null) {
      this.vWKayit = navParams.get("vWKayit");
      // var data = new FormData();
      // data.append("Servis_id", this.vWKayit.ID);
      // this.bllOrtak.islem(data, "HareketDetayGetirByID", "", false).then(a => {
      //   var Sonuc = <any>a;
      //   this.HareketListesi = Sonuc.SonucObject;

      //})
    }
  }

  ionViewDidLoad() {
    this.hareketgetir();
  }
  kapat() {
    this.viewCtrl.dismiss();
  }
  hareketgetir() {
    var formData = new FormData();
    this.hareketid = this.vWKayit.ID;
    formData.append("Servis_id", this.hareketid);
    this.bllOrtak.islem(formData, "ServisHareketGetirByID", "", false).then(a => {
      var sonuc = <any>a;
      this.HareketListesi = sonuc.SonucObject;
    
    })

  }
  kayitduzenle(hareket) {
    let modal = this.modalCtrl.create(ServishareketduzenlePage, { vWKayit: hareket });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
  }
  kayitsil(hareket) {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();
      formData.append("ID", hareket.ID);
      this.bllOrtak.islem(formData, "ServisHareketSil", "", true).then(a => {
        var sonuc = <any>a;
        if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
        this.hareketgetir();
      }).catch(x => {
        this.ortak.showErrorAlert();
      })
    })
  }


}



// WEBPACK FOOTER //
// ./src/pages/ServisKayit/servishareketdetay/servishareketdetay.ts